



















import { defineComponent, PropType } from '@vue/composition-api'
import { useActions, useGetters, useState } from 'vuex-composition-helpers'

import { IImpersonationConfig } from '../../models/config-interface'

import ButtonAtom from '@/shared/components/atoms/ButtonAtom.vue'
import FormSelectComponent from './FormSelectComponent.vue'
import StudySelectComponent from './StudySelectComponent.vue'

export default defineComponent({
    name: 'Impersonation',
    components: {
        ButtonAtom,
        FormSelectComponent,
        StudySelectComponent
    },
    props: {
        config: {
            type: Object as PropType<IImpersonationConfig>,
            required: true
        }
    },
    setup: (props) => {
        const { init, save, reset } = useActions('impersonation', ['init', 'save', 'reset'])
        const { canReset, filters, formIsValid, labels, showStudySelector, dataIsModified } = useGetters('impersonation', ['canReset', 'filters', 'formIsValid', 'labels', 'selectedOption', 'showStudySelector', 'dataIsModified'])
        const { error, loading, studies } = useState('impersonation', ['error', 'loading', 'studies'])

        init(props.config)

        return {
            canReset,
            dataIsModified,
            error,
            filters,
            formIsValid,
            labels,
            loading,
            studies,
            showStudySelector,
            save,
            reset
        }
    }
})
